import { useState, useEffect } from "react";
import { useShopify } from '../store/shopifyReducer'
import { getUserInfo, getUserCartInfo } from "@/utils/useUserInfo";
import { CART_TOKEN,GCART_TOKEN } from "@/utils";
function useShopifyCheckout() {
    const {
        checkoutState,
        createCheckout,
        addVariant,
        getClient,
        checkoutID
    } = useShopify();

    const [products, setProducts] = useState<any>([])
    const [checkoutLoaded, setCheckoutLoaded] = useState(false);
    const [availabilityUpdated, setAvailabilityUpdated] = useState(false);
    const [productAvailabilty, setProductAvailability] = useState('unavailable');
    const [productVariantId, setProductVariantId] = useState<any>([]);
    //the following two effects, loadShopifyCheckout and updateProductAvailability ensure that we
    //handle 'Add to cart'/'Unavailable' situations correctly. this code ideally should
    //go into a custom hook and we should use this hook both here and project_details page.
    const [userInfo, setUserInfo] = useState<any>({})
    useEffect(() => {
        async function fetchLatestUserInfo() {
            try {
                const res = await getUserInfo('', true)
                const cartData = await getUserCartInfo(res)
                console.log(cartData, '----------------------------->', res)
                if(cartData?.error){
                    res['crtD'] = cartData
                }
                setUserInfo({ ...res, ...cartData })
            } catch (error) {
                console.log(error)
            }
        }
        fetchLatestUserInfo()
    }, [])
    useEffect(() => {
        async function loadShopifyCheckout() {
            let checkoutId = null;
            if (Object.keys(userInfo).length === 0) {
                console.log('🛒 [Cart API v3.0] No user info available, skipping checkout load');
                return;
            }
            // if (typeof window !== 'undefined' && userInfo?.status == 'DONE') {
            try {
                console.log('🛒 [Cart API v3.0] Loading Shopify checkout for user:', userInfo.cId);
                checkoutId = userInfo?.crtD?.cartId
                if (!checkoutId) {
                    console.log('🛒 [Cart API v3.0] No cart ID found in user data, fetching from API');
                    const cartData = await getUserCartInfo(userInfo);
                    console.log('🛒 [Cart API v3.0] Cart data from API:', cartData);
                    checkoutId = cartData.cartId;
                } else {
                    console.log('🛒 [Cart API v3.0] Using existing cart ID from user data:', checkoutId);
                }
                //@ts-ignore
                checkoutId = checkoutId || window.getCookie(CART_TOKEN);
                checkoutId = (checkoutId == "null" || checkoutId == "undefined") ? null : checkoutId;

                if (!checkoutId) {
                    console.log('🛒 [Cart API v3.0] No logged-in cart found, checking guest cart');
                    //@ts-ignore
                    checkoutId = window.getCookie(GCART_TOKEN);
                    checkoutId = (checkoutId == "null" || checkoutId == "undefined") ? null : checkoutId;
                }
                //if checkout is empty create checkout or if checkout Id is present get the data from shopify
                console.log('🛒 [Cart API v3.0] Creating/loading checkout with cart ID:', checkoutId);
                await createCheckout({ checkoutId });
                console.log('✅ [Cart API v3.0] Checkout creation/loading completed');
            } catch (error) {
                console.error('❌ [Cart API v3.0] Error creating/loading checkout:', error);
                setProductAvailability('unavailable');
            }
            setCheckoutLoaded(true);
            console.log('🛒 [Cart API v3.0] Checkout loading process completed');
            // }
        }
        loadShopifyCheckout();
    }, [userInfo])

    useEffect(() => {
        if (products.length === 0) return
        async function updateProductAvailability() {
            setProductVariantId([])
            for (let eachProduct of products) {
                const shopifyProductId = 'gid://shopify/Product/' + eachProduct.productShopifyId;
                console.log('--------ProductDetails fetchShopifyInformation--------', 'shopifyProductId:', shopifyProductId);
                //@ts-ignore
                try {
                    const shopifyProd = await getClient().product.fetch(shopifyProductId);
                    console.log('--------ProductDetails fetchShopifyInformation--------', 'shopify Prod: ', shopifyProd);
                    if (shopifyProd) {
                        const variant = shopifyProd?.variants[0];
                        if (variant) {
                            setProductVariantId((prevState:any) => [...prevState, { variantId: variant.id, quantity: 1 }]);

                            setProductAvailability('available');
                        }
                    }
                } catch (error) {
                    console.error("Error fetching product from shopify", error);
                    setProductAvailability('unavailable');
                }
                setAvailabilityUpdated(true);
            }

        }
        if (checkoutLoaded) {
            updateProductAvailability();
        }
    }, [checkoutLoaded, products])
    return [productVariantId, setProducts, userInfo]
}
export default useShopifyCheckout